<template>
  <v-app id="inspire">
    <v-app id="inspire">
      <v-main>
        <v-container class="fill-height" fluid>
          <v-snackbar top v-model="snackbar" :color="colorSnackbar">
            {{ textAlert }}
            <template v-slot:action="{ attrs }">
              <v-btn dark text v-bind="attrs" @click="snackbar = false">
                Close
              </v-btn>
            </template>
          </v-snackbar>
          <v-row align="center" justify="center">
            <v-col cols="12" sm="8" md="4">
              <v-card class="pb-3 elevation-12">
                <v-card-title primary-title>
                  <img src="@/assets/tmn.png" width="100px" alt="tmn logo" />
                  <p class="title mb-0">Target Media Nusantara</p>
                </v-card-title>
                <div class="mx-3">
                  <v-form class="mt-2" @submit.prevent="login">
                    <v-text-field
                      v-model="credentials.email"
                      class="mb-3"
                      label="Email"
                      placeholder="youremail@here.com"
                      :rules="emailRules"
                      required
                    />
                    <v-text-field
                      v-model="credentials.password"
                      class="mb-3"
                      label="Password"
                      placeholder="Input your easy password"
                      type="password"
                      :rules="passwordRules"
                      required
                    />
                    <div class="text-center pb-2">
                      <v-btn type="submit" color="primary" depressed>
                        Login
                      </v-btn>
                    </div>
                  </v-form>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-main>
    </v-app>
  </v-app>
</template>

<script>
import axios from "axios";
import { setToken, setRole } from "./utils/auth";

export default {
  data() {
    return {
      snackbar: false,
      colorSnackbar: "",
      textAlert: "",
      credentials: {
        email: "",
        password: ""
      },
      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+/.test(v) || "E-mail must be valid"
      ],
      passwordRules: [
        v => !!v || "Password is required",
        v => v.length >= 5 || "Password minimal 8 characters long"
      ]
    };
  },
  methods: {
    async login() {
      let url = `${process.env.VUE_APP_API_URL}/api/admin/login`;
      let headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + process.env.VUE_APP_API_KEY
      };
      await axios
        .post(url, this.credentials, { headers: headers })
        .then(res => {
          if (res.data.status === "success") {
            setToken(res.data.data.api_token);
            setRole(res.data.data.role);

            // TODO: rework auth
            const mappingRole = res.data.data.priviledge_list.filter(
              pl => pl.id === 129
            ); // 129 are the mapping analytics role
            if (mappingRole.length) {
              window.localStorage.setItem("mapping-analytics", "1");
            } else {
              window.localStorage.setItem("mapping-analytics", "0");
            }

            this.snackbar = true;
            this.colorSnackbar = "success";
            this.textAlert = "Login success";

            this.$router.push("/");
          } else if (res.data.status === "failed") {
            this.snackbar = true;
            this.colorSnackbar = "error";
            this.textAlert = "Invalid email or password";

            setTimeout(() => {
              this.$router.push("/login");
            }, 3000);
          }
        })
        .catch(err => {
          throw new Error(err);
        });
    }
  }
};
</script>
